
/*
Author: Vinod
Issue Description: The financial year need to be corrected from UI.
Issue Id: PL-2664
search_string: PL_2664
 */

 /*
Author: Vinod
Issue Description: Auto suggest should start after entering 3 letters.
Issue Id: PL-2996
search_string: PL_2996
 */

  /*
Author: Vinod
Date: 07/04/2020
Issue Description: Not able to download payslip. Please change the month name in request.
search_string: PL_3042
 */

<template>
  <div class="main-container">
    <div class>
      <breadcrumb :list="breadcrumbList" />
      <tl-header type="h1">
        <div class="main-header">Payslips & IT sheet</div>
      </tl-header>
      <br />
      <div class="model" v-if="report_download">
        <span class="loader"></span>
        <span>Loading...........</span>
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission && (role !=='EMPLOYEE' && role !=='HR')">
        You have only view permission.
      </div> 
      <section class="filters">
        <date-picker
          class="customwidth"
          :initialView="'month'"
          :formatDate="'MMMM-yyyy'"
          :maximumView="'year'"
          :minimumView="'month'"
          :datesDisabled="{from:new Date(new Date().setDate(new Date().getDate() - 1))}"
          @datevalue="(val)=>getFormattedMonth(val)"
          :value="month"
        />
      </section>

      <div class="row margin-t-m" :disabled="!ifTeamleaderAnchorPermission" v-show="(role !=='EMPLOYEE' && role !=='HR')">
        <div class="col-3 padding-l-n">
          <tl-select
            label="Paygroup"
            labelText="name"
            v-model="paygroup"
            :multiple="true"
            :options="paygroupOptions"
            @change="(val)=>paygroup = val"
          />
        </div>
        <!-- <div class="col-3">
          <tl-select
            label="Criteria"
            v-model="criteria"
            :options="criteriaOptions"
            @change="(val) => {criteria = val;onSelectCriteria(val)}"
          />
        </div>
        <div class="col-3" v-if="subCriteriaLabel">
          <tl-select
            :label="subCriteriaLabel"
            labelText="name"
            v-model="subcriteria"
            :multiple="true"
            :options="subCriteriaList"
            @change="(val)=>subcriteria = val"
          />
        </div> -->
        <div class="col-3 filterButton" >
          <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilters"></btn>
        </div>
      </div>

      <div class="searchsort margin-tb-l" :disabled="!ifTeamleaderAnchorPermission" v-show="(role !=='EMPLOYEE' && role !=='HR')">
        <!-- PL_2996 -->
        <search-dropdown
          label="Search Employee"
          v-model="searchText"
          placeholder="Please enter at least 3 characters"
          :employeeData="customEmpList"
          @getList="getEmployeesByName($event)"
          @empselected="(emp)=>selectedEmp(emp)"
        />

        <!-- Below code is comment because their no connection with data table  -->
        <!-- <div class="sorttext">
          <span>Sort By:</span>
        </div>&nbsp; &nbsp; &nbsp;
        <tl-select
          class="customwidth"
          :value="filterType.designation"
          :options="['Recently Joined', 'Admin', 'IT']"
        /> -->
      </div>
    </div>
    <!-- PL_2996 -->
    <div
      v-if="employeeList.length==0" v-show="ifTeamleaderAnchorPermission"
    ><strong>No Data Available For The Above Criteria</strong></div>

    <div style="display: flex; gap: 10px;" v-show="(role =='EMPLOYEE' || role =='HR') ">
      <div class="employeeDownload" @click="downloadEssPayslip()" v-show="!ifTeamleaderAnchorPermission">
        <img src="@/assets/download.svg"  class="downloadImg" />
        <span class="downloadText">Payslip</span>
      </div>
      <div class="employeeDownload" @click="downloadEssITSheet()" v-show="!ifTeamleaderAnchorPermission">
        <img src="@/assets/download.svg"  class="downloadImg" />
        <span class="downloadText">IT Sheet</span>
      </div>
    </div>

    <div
      v-if="employeeList.length && totalEmployees"
    >{{employeeList.length}}&nbsp;/&nbsp; {{totalEmployees}}</div>
    <div class="table-div" v-if="employeeList.length" ref="table_div" @scroll="onScroll()">
      <data-table
        :columns="columnNames"
        :tableData="employeeList"
        :showinrow="false"
        :withForm="false"
        :disableEdit="false"
        :headcheckbox="false"
        :disable-delete="true"
        :actionbtn="true"
        :showinheader="false"
        :search="search"
        :icons="[
                   {url:require('@/assets/garbage.png'), method: 'up'},
                   {url:require('@/assets/garbage.png'), method: 'down'},
                   {url:require('@/assets/garbage.png'), method: 'deletee'}
                   ]"
      >
        <template v-slot:rowcontent="slotprops">
          <img
            class="sm-img"
            v-if="slotprops.value.column.key=='imgSrc'"
            :src="slotprops.value.record[slotprops.value.column.key]"
          />
          <p
            v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key !='attachments'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <!-- <p v-if="slotprops.value.column.key=='attachments'">
            <span class="attach-content" v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]" :key="index">
              <img class="atch-img" :src="require('@/assets/garbage.png')" />
              <a class="file-name input-label font-size-14" href="">
                {{item.filename}}</a>
            </span>
          </p>-->
          <!-- v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]" :key="index" -->
          <div v-if="slotprops.value.column.key=='attachments'">
            <!-- <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a href="javascript:void(0)" @click="downloadPayslip(slotprops.value.record)">Payslip</a>
            </span>
            <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a
                href="javascript:void(0)"
                @click="downloadITSheet(slotprops.value.record['id'])"
              >IT Sheet</a>
            </span> -->
            <div  class="downLoadBtn">
              <button @click="postEmpDetailes(slotprops.value.record)" class="export-button">Payslip</button>
              <!-- <button v-if="isAllowedV1"  @click="downloadPayslipv1(slotprops.value.record)" class="export-button">Payslip v1</button> -->
              <button @click="DownloadItSheetWithEmpDetailes(slotprops.value.record)" class="export-button">IT Sheet</button>
              <button @click="DownloadItSheetWithExcel(slotprops.value.record)" class="export-button">IT Sheet(Excel)</button>
              <button @click="DownloadYtdWithEmpDetailes(slotprops.value.record)" class="export-button">YTD Report</button>
              <!-- <button @click="DownloadCtcReport(slotprops.value.record)" class="export-button">CTC Report</button> -->
              <button @click="DownloadCtcReportV1(slotprops.value.record)" class="export-button">CTC Report</button>
              <button v-if="credentialSpecific" @click="DownloadCtcReport(slotprops.value.record)" class="export-button">CTC Report (ESS)</button>
              

            </div>
            <!-- <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a href="javascript:void(0)" @click="downloadNewPayslip(slotprops.value.record)">Payslip</a>
            </span>
            <span class="attach-content">
              <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
              <a
                href="javascript:void(0)"
                @click="downloadNewITSheet(slotprops.value.record)"
              >IT Sheet</a>
            </span> -->
          </div>

          <!-- dropdown section starts here -->
          <!-- <div class="action-section" v-if="slotprops.value.column.key=='action'">
          <a href="http://ec2-13-234-115-126.ap-south-1.compute.amazonaws.com:8081/template/download/employeesalaryregister?id=6ad4b2a3-1f4a-40d6-939c-8e2b789b3675" target="_blank" download=true>Download</a>-->
          <!-- <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon" />
            <ul class="action-menu" v-show="employeeList[slotprops.value.index].showDropDown">
              <li @click="download(slotprops.value.record)">
                <span class>Download</span>
              </li>
              <li @click="sendEmail(slotprops.value.record)">
                <span class>Send Email</span>
              </li>
              <li @click="sendESS(slotprops.value.record)">
                <span class>Send ESS</span>
          </li>-->
          <!-- </ul>
          </div>-->
          <!-- dropdown section ends here -->
        </template>

        <!-- <template v-slot:headercontent="slotprops">
          <div class="action-container">
            <tl-checkbox :checked="true" @change="headerCheckboxChecked()" />
            <button class="export-button" v-on:click="download">Download</button>
            <button class="export-button" v-on:click="sendEmail">Send Email</button>
            <button class="export-button" v-on:click="sendESS">Send ESS</button>
            <div class="action-menu" id="download" v-if="showDownloadableContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <download-button></download-button>
                </div>
              </div>
            </div>
            <div class="action-menu" id="email" v-if="showSendEmailContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <btn
                    class="noBorder-btn"
                    text="Send Email"
                    type="secondary"
                    v-on:click="confirmSendEmail"
                  ></btn>
                </div>
              </div>
            </div>
            <div class="action-menu" id="ess" v-if="showSendESSContent">
              <div class="checkbox-content">
                <tl-checkbox label="Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="FBP Payslips" />
              </div>
              <div class="checkbox-content">
                <tl-checkbox label="IT Sheets" />
              </div>
              <div class="dropdown-footer">
                <div class="download-btn">
                  <btn
                    class="noBorder-btn"
                    text="Send ESS"
                    type="secondary"
                    v-on:click="confirmSendESS"
                  ></btn>
                </div>
              </div>
            </div>
          </div>
        </template>-->
      </data-table>
    </div>
    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="secondary" class v-on:click="back"></btn>
      </btn-grp>
    </bottom-action-container>

    <!-- Payslip preview modal -->
    <div class="modal custom-modal" v-if="showCreateModal">
      <div class="modal-content modal-sm payslip-modal">
        <div class="modal-header">
          <h3>Payslip Preview</h3>
        </div>
        <div class="modal-body content-center">
          <div>
            <img src="@/assets/preview.png" />
          </div>
          <div class="download-btn">
            <div class="download-btn-container row download-content">
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download Payslip</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to Email</span>
              </div>
              <div class="rigth-margin-10">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Send to ESS</span>
              </div>
              <btn-grp slot="end">
                <btn
                  class="cancel-btn"
                  text="Cancel"
                  type="secondary"
                  v-on:click="cancelPreviewDownload"
                ></btn>
              </btn-grp>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import {
  criteriaObj,
  monthOptionsObj
} from "../../../../../../../apis/constants.js";
const crypto = require("crypto");
export default {
  components: {
    SearchDropdown
  },

  data() {
    return {
      report_download: false,
      selectedRecordsList: [],
      month: "",
      currentMonth: 0,
      filterType: {
        month: null,
        legalEntity: null,
        department: null,
        location: null,
        costCenter: null,
        designation: null
      },
      searchText: "",
      selectedFilterData: {},
      monthOptions: monthOptionsObj.monthListForFinancialYear.sort(
        (a, b) => a.index - b.index
      ),
      selectedArray: [],
      customEmpList: [],
      showDropdown: false,
      showinheader: false,
      showCreateModal: false,
      subCriteriaLabel: "",
      subcriteria: [],
      paygroup: "",
      criteria: "",
      paygroupOptions: [],
      subCriteriaList: [],
      criteriaOptions: criteriaObj.reportCriteria,
      paySlipMonth: "",
      paySlipYear: "",
      showDownloadableContent: false,
      showSendEmailContent: false,
      showSendESSContent: false,
      toast: false,
      monthValue: null,
      errmsg: "",
      sort: "Recently Joined",
      clientCode:"",
      columnNames: [
        // {
        //   label: "",
        //   key: "imgSrc"
        // },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "first_name"
        },
        {
          label: "Department",
          key: "bu_name"
        },
        {
          label: "Email ID",
          key: "email_id"
        },
        {
          label: "Location",
          key: "location_name"
        },
        {
          label: "Attachments",
          key: "attachments"
        }
      ],
      employeeList: [],
      search: "",
      page: 1,
      totalEmployees: 0,
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/organisation`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },
        {
          name: "Payslips & IT sheet",
          url: ""
        }
      ],
      paySlipsItSheetsValue: false,
      role: "",
      roleId: "",
      newPayslipMonth: null,
      legalEntityName: null,
    };
  },

  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ...mapState({
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      entities: state => state.onboard.legal_entities.data,
      userEmailState: (state) => state.auth.email
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.paySlipsItSheetsValue) {
          return true;
        } else {
          return false;
        }
      }
      // else {
      //   return true
      // }
    },
  //   isAllowedV1() {
  //   const isAllowedV1 = ['sathishkumar.rajendiran@teamlease.com', 'sagar.shetty@teamlease.com','akash.kumar@teamlease.com','asif.khan@teamlease.com','rakshitha.raj@teamlease.com'];
  //   return isAllowedV1.includes(localStorage.getItem('loginId'));
  // }
  },

  activated() {
    this.page = 1;
    this.refresh();
    this.getPaygroups();
    this.getCurrentMonth();
    this.getOrgLeIdList();
    this.credentialSpecific = this.credentialCheck();

  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByLeAndName", // PL_2996
      fetchEmployees: "dashboard/payroll/reports/Reports/fetchAll",
      downloadpayslip:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      itsheet:
        "dashboard/organisation/utilities/itsheetandpayslip/downloadITSheet",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      act_download_new_payslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewPayslips",
      act_download_new_itSheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewItsheet",
      act_download_YTD_report:"dashboard/organisation/utilities/itsheetandpayslip/downloadYtdsheet",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
      act_post_emp_details:"dashboard/organisation/utilities/itsheetandpayslip/postEmpDetails",
      act_download_CTC_report: "dashboard/organisation/utilities/itsheetandpayslip/ctcReport",
      act_generate_itsheet_excel:"dashboard/organisation/utilities/itsheetandpayslip/generateItsheetExcel",
      download_reports:"dashboard/organisation/utilities/itsheetandpayslip/downloadReports",
    }),

    // headerCheckboxChecked() {
    //   this.showinheader = false;
    // },

    /* function to get fiancial year */
    getFormattedMonth(val) {
      try {
        this.paySlipMonth = this.monthOptions[new Date(val).getMonth()].name;
        this.monthValue = this.monthOptions[new Date(val).getMonth()].value;
        this.paySlipYear = new Date(val).getFullYear(); // PL_2664
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    credentialCheck() {
      const allowedEmails = [
        "sagar.shetty@teamlease.com",
        "asif.khan@teamlease.com",
        "rakshitha.raj@teamlease.com",
        "abhishek.venkatesh@teamlease.com",
        "abhishek.reddy@teamlease.com",
        "sathishkumar.rajendiran@teamlease.com",
        "akash.kumar@teamlease.com",
        "mukesh.kumar@teamlease.com"
      ];
      return allowedEmails.includes(this.userEmailState);
    },

    /* function get current month */
    getCurrentMonth() {
      try {
        this.month = this.payrollMonth ? this.payrollMonth+"-"+this.payrollYear : new Date();
        var today = new Date();
        this.currentMonth = today.getMonth();
        // this.getFormattedMonth(today);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.paygroup = [];
        this.criteria = null;
        this.subcriteria = [];
        this.subCriteriaList = []; // PL_2996
        this.employeeList = [];
        this.subCriteriaLabel = null; // PL_2996
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getLegalEntityName(value){
      this.entities.map(item => {
        if(value == item.id){
          this.legalEntityName =  item.legalName;
          this.clientCode = item.clientCode;
        }
      })
    },

    /* server call to download the payslip of an employee */
    async downloadPayslip(empDetails) {
      try {
        let res = await this.downloadpayslip({
          le_id: this.leId,
          empId: empDetails.id, // PL_3042
          org_id: this.orgId,
          paygroup_id: empDetails.paygroup_id, // PL_3042
          financialYear: this.paySlipYear,
          month: this.monthValue // PL_3042
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    //Function to download new payslips
    // async downloadNewPayslip(empDetails) {
    //   try{
    //     this.postEmpDetailes(empDetails)
    //     let obj = {
    //       'employee_id': empDetails.id
    //     };
    //     await this.getMonthName(this.monthValue);
    //     await this.getLegalEntityName(this.leId);
    //     let response = await this.act_getProfileData(obj);
    //     this.employeeData = response.data.payload[0];
    //     let payslipObj = {
    //       empCode: this.employeeData.code,
    //       payMonth: this.newPayslipMonth,
    //       clientName: this.legalEntityName,
    //       legalEntityId: this.leId,
    //       clientCode: this.clientCode,
    //       reportType: "pdf",
    //       paymentYear: this.paySlipYear,
    //     }
    //     let data = await this.encryptData(payslipObj);
    //     // let res = await this.act_download_new_payslip(data);
    //     let apiResponse = JSON.parse(await this.decrypt(res.data.data));
    //     const url = apiResponse[0].pdfPreSignedUrl;
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "Payslip.pdf"); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = "Details not Fetched";
    //   }
    // },
    
    //Function to download new payslips with empDetails
    async postEmpDetailes(empDetails){
      this.report_download = true;
      try{
        let obj = {
          'employee_id': empDetails.id
        };
        let response = await this.act_getProfileData(obj);
       let empData = response.data.payload[0];
          let payload={
                        clientName:empData.legalEntityDetails.legalName,
                        type:"paySlip",
                        empCode:empData.code,
                        empId:empData.id,
                        empName:empData.first_name,
                        empPan:empData.pan_number,
                        empGender:empData.gender,
                        empDesigation:empData.designation,
                        empDoj:empData.date_of_joining,
                        empEmail:empData.permanent_address.email,
                        empEsiNum:null,
                        empMobile:empData.mobile_number,
                        empUAN:null,
                        empPran:empData.pran_number,
                        dob:empData.dob,
                        gender:empData.gender,
                        assesmentYear:this.paySlipYear,
                        month:this.monthValue,
                        registeredAddress: {
                           email:"",
                           cityID:"",
                           stateID:"",
                           countryID:"",
                           phoneNumber:"",
                           pincode:empData.legalEntityDetails.registeredAddress.pincode,
                           addressLineOne:empData.legalEntityDetails.registeredAddress.addressLineOne,
                           addressLineTwo:empData.legalEntityDetails.registeredAddress.addressLineTwo
                            },
                        logoUrl:empData.legalEntityDetails.logoURL,
                        companyPan:empData.legalEntityDetails.PANNumber,
                        companyTan:empData.legalEntityDetails.TANNumber,
                        location: {
                          
                              id: empData.based_location_id,
                              createdBy: null,
                              updatedBy: null,
                              customAttr: null,
                              le_id: empData.legalEntityDetails.id,
                              industry_type: null,
                              name:null,
                    address: {
                         cityID:empData.communication_address.cityID,
                         pincode: empData.communication_address.pincode,
                         stateID: empData.communication_address.stateID,
                         city_name: empData.communication_address.cityName,
                         countryID: empData.communication_address.countryID,
                         state_name: empData.communication_address.stateName,
                         addressLineOne: empData.communication_address.addressLineOne,
                         addressLineTwo: empData.communication_address.addressLineTwo
        }
    
                        },
                        legalEntity:{
                                     id: empData.legalEntityDetails.id,
                                     name: empData.legalEntityDetails.legalName,
                                     clientCode: empData.legalEntityDetails.clientCode
                                                     }
            

                       }
                let data = await this.encryptData(payload);  
                let res = await this.act_post_emp_details(data)
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if(apiResponse.data.success){
                const url = apiResponse.data.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                }else{
                  this.toast = true;
                  this.errmsg = apiResponse.data.message;
                }
                this.report_download = false;
      }catch(err){
        this.report_download = false;
          this.toast = true;
        this.errmsg = err.message;
      }
    },
    // async downloadPayslipv1(empDetails) {
    //   this.toast = false;
    //   this.report_download = true;
    //   try {
    //     let obj = {
    //       employee_id: empDetails.id,
    //     };
    //     let response = await this.act_getProfileData(obj);
    //     let empData = response.data.payload[0];
    //     let accountNo = "";
    //     let paymentType="Cash";
    //     if (
    //       empData &&
    //       empData.paymentDetails &&
    //       Array.isArray(empData.paymentDetails.accounts) &&
    //       empData.paymentDetails.accounts.length > 0 &&
    //       empData.paymentDetails.accounts[0].account_number
    //     ) {
    //       accountNo = empData.paymentDetails.accounts[0].account_number;
    //       paymentType=empData.paymentDetails.accounts[0].paymentType;
    //     }
    //     let payload = {
    //       downloadType: "direct",
    //       clientName: empData.legalEntityDetails.legalName,
    //       type: "paySlip",
    //       empCode: empData.code,
    //       empId: empData.id,
    //       empName: empData.first_name,
    //       empPan: empData.pan_number,
    //       empGender: empData.gender,
    //       empDesigation: empData.designation,
    //       empDoj: empData.date_of_joining,
    //       empEmail: empData.permanent_address.email,
    //       empEsiNum: null,
    //       empMobile: empData.mobile_number,
    //       empUAN: null,
    //       dob: empData.dob,
    //       gender: empData.gender,
    //       assesmentYear: this.paySlipYear,
    //       month: this.monthValue,
    //       accountNumber:accountNo,
    //       departmentName: empData.department,
    //       PFNumber:empData.empPFESIDetails.pf_number,
    //       empUAN:empData.empPFESIDetails.uan_number,
    //       modeOfPayment:paymentType,
    //       registeredAddress: {
    //         email: "",
    //         cityID: "",
    //         stateID: "",
    //         countryID: "",
    //         phoneNumber: "",
    //         pincode: empData.legalEntityDetails.registeredAddress.pincode,
    //         addressLineOne:
    //           empData.legalEntityDetails.registeredAddress.addressLineOne,
    //         addressLineTwo:
    //           empData.legalEntityDetails.registeredAddress.addressLineTwo,
    //         cityID: empData.legalEntityDetails.registeredAddress.cityID,
    //       },
    //       logoUrl: empData.legalEntityDetails.logoURL,
    //       companyPan: empData.legalEntityDetails.PANNumber,
    //       companyTan: empData.legalEntityDetails.TANNumber,
    //       location: {
    //         id: empData.based_location_id,
    //         createdBy: null,
    //         updatedBy: null,
    //         customAttr: null,
    //         le_id: empData.legalEntityDetails.id,
    //         industry_type: null,
    //         name: null,
    //         address: {
    //           cityID: empData.communication_address.cityID,
    //           pincode: empData.communication_address.pincode,
    //           stateID: empData.communication_address.stateID,
    //           city_name: empData.communication_address.cityName,
    //           countryID: empData.communication_address.countryID,
    //           state_name: empData.communication_address.stateName,
    //           addressLineOne: empData.communication_address.addressLineOne,
    //           addressLineTwo: empData.communication_address.addressLineTwo,
    //         },
    //       },
    //       legalEntity: {
    //         id: empData.legalEntityDetails.id,
    //         name: empData.legalEntityDetails.legalName,
    //         clientCode: empData.legalEntityDetails.clientCode,
    //         logoUrl: empData.legalEntityDetails.logoURL,
    //       },
    //     };
    //     let data = await this.encryptData(payload);
    //     // let res = await this.act_post_emp_details(data)
    //     let res = await this.download_reports(data);
    //     this.report_download = false;    
    //     if (res.status === 200) {
    //       let apiResponse = JSON.parse(
    //         await this.decrypt(JSON.parse(await res.data.text()))
    //       );
    //       this.toast = true;
    //       this.errmsg = apiResponse.data.message;
    //     } else if (res.status === 201) {
    //       const fileName = `${payload.legalEntity.clientCode}_${payload.empCode}_${this.payrollMonth}_${this.payrollYear}.pdf`;
    //       try {
    //         const blob = new Blob([res.data], { type: "application/pdf" });
    //         const url = window.URL.createObjectURL(blob);

    //         const link = document.createElement("a");
    //         link.href = url;

    //         link.setAttribute("download", fileName);
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         window.URL.revokeObjectURL(url);
    //       } catch (err) {
    //         console.error("Error downloading PDF:", err);
    //       }
    //     } else {
    //       this.toast = true;
    //       this.errmsg = `Something went wrong from server side`;
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err.message;
    //   }
    // },
    //api to download payslips from ess end
    async downloadEssPayslip() {
      try {
        let res = await this.downloadpayslip({
          empId: this.roleId,
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    async DownloadItSheetWithExcel(empDetails) {
      try {
        this.report_download = true;
        let data = {
          leId: this.leId,
          month: this.monthValue,
          year: String(this.paySlipYear),
          empCode: empDetails.code
        }
        let response = await this.act_generate_itsheet_excel(data);
        if(response && response.data && response.data.data ) {
          const url = response.data.data.data;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Payslip.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.report_download = false;
      } catch (error) {
        let err = error.response.data;
        this.report_download = false;
        this.toast = true;
        this.errmsg = err.message;
      }
    },

    async downloadEssITSheet() {
      try {
        let res = await this.itsheet(
        {
          le_id: this.leId,
          empId: this.roleId, 
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    /* server call to download IT Sheet of an employee */
    async downloadITSheet(id) {
      try {
        let res = await this.itsheet(
        {
          le_id: this.leId,
          empId: id, 
          financialYear: this.paySlipYear,
          month: this.monthValue 
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

      //Function to download new ITSheet with empDetails
    async DownloadItSheetWithEmpDetailes(empDetails){
      this.report_download = true;
      try{
        let obj = {
          'employee_id': empDetails.id
        };
        let response = await this.act_getProfileData(obj);
       let empData = response.data.payload[0];
          let payload={
                        clientName:empData.legalEntityDetails.legalName,
                        type:"ITSheet",
                        empCode:empData.code,
                        empId:empData.id,
                        empName:empData.first_name,
                        empPan:empData.pan_number,
                        empGender:empData.gender,
                        empDesigation:empData.designation,
                        empDoj:empData.date_of_joining,
                        empEmail:empData.permanent_address.email,
                        empEsiNum:null,
                        empMobile:empData.mobile_number,
                        empUAN:null,
                        empPran:empData.pran_number,
                        dob:empData.dob,
                        gender:empData.gender,
                        assesmentYear:this.paySlipYear,
                        month:this.monthValue,
                        registeredAddress: {
                           email:"",
                           cityID:"",
                           stateID:"",
                           countryID:"",
                           phoneNumber:"",
                           pincode:empData.legalEntityDetails.registeredAddress.pincode,
                           addressLineOne:empData.legalEntityDetails.registeredAddress.addressLineOne,
                           addressLineTwo:empData.legalEntityDetails.registeredAddress.addressLineTwo
                            },
                        logoUrl:empData.legalEntityDetails.logoURL,
                        companyPan:empData.legalEntityDetails.PANNumber,
                        companyTan:empData.legalEntityDetails.TANNumber,
                        location: {
                          
                              id: empData.based_location_id,
                              createdBy: null,
                              updatedBy: null,
                              customAttr: null,
                              le_id: empData.legalEntityDetails.id,
                              industry_type: null,
                              name:null,
                    address: {
                         cityID:empData.communication_address.cityID,
                         pincode: empData.communication_address.pincode,
                         stateID: empData.communication_address.stateID,
                         city_name: empData.communication_address.cityName,
                         countryID: empData.communication_address.countryID,
                         state_name: empData.communication_address.stateName,
                         addressLineOne: empData.communication_address.addressLineOne,
                         addressLineTwo: empData.communication_address.addressLineTwo
        }
    
                        },
                        legalEntity:{
                                     id: empData.legalEntityDetails.id,
                                     name: empData.legalEntityDetails.legalName,
                                     clientCode: empData.legalEntityDetails.clientCode
                                                     }
            

                       }
                let data = await this.encryptData(payload);  
                let res = await this.act_post_emp_details(data)
                let apiResponse = JSON.parse(await this.decrypt(res.data));
                if(apiResponse.data.success){
                const url = apiResponse.data.data.pdfPreSignedUrl;
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                }else{
                  this.toast = true;
                  this.errmsg = apiResponse.data.message;
                }
                this.report_download = false;
      }catch(err){  
        this.toast = true;
        this.report_download = false;
        this.errmsg = err.message;
      }
    },
    async DownloadCtcReport(empDetails) {
      try {
        this.report_download = true;
        let obj = {
          empCode: empDetails.code,
          legalEntityId: this.leId
        };
        let data = await this.encryptData(obj);
        let response = await this.act_download_CTC_report(data);
        let apiResponse = JSON.parse(await this.decrypt(response.data));
        if (apiResponse.success) {
          const url = apiResponse.data.pdfPreSignedUrl;
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Payslip.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          this.toast = true;
          this.errmsg = apiResponse.message;
        }
        this.report_download = false;
      } catch (err) {
        this.toast = true;
        this.report_download = false;
        this.errmsg = err.message;
      }
    },
    async DownloadCtcReportV1(empDetails) {
      try {
        this.report_download = true;
        let payload = {
          // empCode: empDetails.code,
          // legalEntityId: this.leId,
          leId: this.leId,
          empId: empDetails.id,
          type: "ctcReport",
          downloadType: "direct"
        };
       let data = await this.encryptData(payload);
        let res = await this.download_reports(data);
         if (res.status === 200) {
          let apiResponse = JSON.parse(
            await this.decrypt(JSON.parse(await res.data.text()))
          );
          this.toast = true;
          this.errmsg = apiResponse.data.message;
        } else if (res.status === 201) {
         const fileName = `ctc_report_${empDetails.code}.pdf`;
          try {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (err) {
            console.error("Error downloading PDF:", err);
          }
        } else {
          this.toast = true;
          this.errmsg = `Something went wrong from server side`;
        }
        this.report_download = false;
      } catch (err) {
        console.error("Error downloading CTC report:", err);
        this.toast = true;
        this.report_download = false;
        this.errmsg = err.message;
      }
    },
    async DownloadYtdWithEmpDetailes(empDetails){
      try{
        this.report_download = true;
        let roleState=localStorage.getItem("userRole")
        if(roleState === "ADMIN"){
          roleState = "ADMIN"  
        }
        else if ( roleState === "EMPLOYEE"){
          roleState = "EMPLOYEE"
        }
        else if ( roleState === "TEAMLEADER"){
            roleState = "ADMIN"
        }
        else if(roleState === "CLIENTADMIN"){
          roleState = "ADMIN"
        }
        let obj={
          empId:empDetails.id,
          financialYear:this.paySlipYear,
          role:roleState,
          month:this.monthValue,
          legal_entity_id: this.leId
        }
        this.showLoader=true;
        let res = await this.act_download_YTD_report(obj);
        this.showLoader=false;
        this.toast=false;
        this.report_download = false;
      }
      
      catch(err){  
        this.toast = true;
        this.report_download = false;
        this.errmsg = err.message;
      }
    },
    //Function to download new IT statement
    // async downloadNewITSheet(empDetails) {
    //   try{
    //    this. DownloadItSheetWithEmpDetailes(empDetails)
    //     let obj = {
    //       'employee_id': empDetails.id
    //     };
    //     await this.getMonthName(this.monthValue);
    //     await this.getLegalEntityName(this.leId);
    //     let response = await this.act_getProfileData(obj);
    //     this.employeeData = response.data.payload[0];
    //     let itObj = {
    //       empCode: this.employeeData.code,
    //       month: this.newPayslipMonth,
    //       clientName: this.employeeData.first_name,
    //       reportType: "pdf",
    //       assesmentYear: this.month.split("-")[1],
    //       clientCode: this.employeeData.legalEntityDetails.clientCode,
    //       legalEntityId: this.employeeData.legal_entity_id
    //     }
    //     let data = await this.encryptData(itObj);
    //     // let res = await this.act_download_new_itSheet(data);
    //     let apiResponse = JSON.parse(await this.decrypt(res.data.data));
    //     const url = apiResponse.pdfPreSignedUrl;            
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "It Sheet.pdf"); //or any other extension
    //     document.body.appendChild(link);
    //     link.click();
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = "Details not Fetched";
    //   }
    // },

    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {

      }
    },

    // dropdown(slots) {
    //   try {
    //     let idx = this.employeeList.findIndex(obj => {
    //       return obj.empId == slots.record.empId;
    //     });

    //     this.employeeList.forEach((data, index) => {
    //       if (index != idx) {
    //         data.showDropDown = false;
    //       }
    //     });
    //     if (idx > -1) {
    //       this.employeeList[slots.index].showDropDown = !this.employeeList[
    //         slots.index
    //       ].showDropDown;
    //     }
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },

    /* server call to get employees by name */
    // Start PL_2996
    async getEmployeesByName(val) {
      try {
        if (val.length >= 3) {
          let res = await this.fetchEmployeeByName({
            key: val,
            le_id: this.leId
          });
          if (res.data.payload) {
            this.customEmpList = res.data.payload;
          }
        } else {
          this.customEmpList = [];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    // End PL_2996

    /* function to select employee */
    selectedEmp(val) {
      this.employeeList = [val];
      this.totalEmployees = this.customEmpList.length; // PL_2996
    },

    /* function to get subcriteria after changing criteria */
    onSelectCriteria(event) {
      this.subcriteria = [];
      try {
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Department") {
          this.subCriteriaLabel = "Department";
          this.getDepartments();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Locations */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary bands */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Paygroups */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
          this.paygroup = this.paygroupOptions[0];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Departments */
    async getDepartments() {
      try {
        let res = await this.fetch_departments(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Cost centres */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary grades */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to apply filters */
    applyFilters() {
      this.page = 1;
      this.employeeList = [];
      this.getEmployeesByApplyingFilter();
    },

    /* server call to get employees after selcting filter options */
    async getEmployeesByApplyingFilter() {
      try {
        let obj = {
          le_id: this.leId,
          month: this.monthValue,
          financial_year: this.paySlipYear,
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Department"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.fetchEmployees({ obj: obj, page: this.page });
        if (res.data.payload) {
          let dataArr = res.data.payload.data;
          this.totalEmployees = res.data.payload.totalEmpCount;
          dataArr.forEach(element => {
            if(!this.employeeList.some(item => item.id == element.id)){
              this.employeeList.push(element);
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeList.length < this.totalEmployees) {
        this.page += 1;
        this.getEmployeesByApplyingFilter();
      }
    },


    /* function to back to utilitie page */
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    },
    // cancelPreviewDownload() {
    //   this.showCreateModal = false;
    // },
    // download() {
    //   try {
    //     this.showDownloadableContent = !this.showDownloadableContent;
    //     this.showSendESSContent = false;
    //     this.showSendEmailContent = false;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },

    // sendEmail() {
    //   try {
    //     this.showDownloadableContent = false;
    //     this.showSendEmailContent = !this.showSendEmailContent;
    //     this.showSendESSContent = false;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },
    // sendESS() {
    //   try {
    //     this.showDownloadableContent = false;
    //     this.showSendEmailContent = false;
    //     this.showSendESSContent = !this.showSendESSContent;
    //   } catch (error) {
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },
    // confirmSendEmail() {},
    // confirmSendESS() {},

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgIds;
        const le = this.leId;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.roleId = data.data.user.employee_id;
        this.paySlipsItSheetsValue = data.data.user.permissions.payslips_it_sheets ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>

.filterButton{
  display: flex;
  align-items: center;
  padding: 0;
}
.table-div {
  height: 250px;
  overflow: auto;
}
.attachment {
  font-size: 14px;
  margin-top: -24px;
}

.text-right {
  text-align: center;
}

.checkbox-content {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
.noBorder-btn {
  border: none !important;
  min-height: 0px !important;
  padding: 0px !important;
}
.content {
  margin-left: 20px;
  margin-top: 15px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}

.sort-by {
  display: flex;
  margin-left: 8%;
  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}

.searchsort {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext {
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
  }
}

.customwidth {
  width: 200px;
  margin-top: 0px;
}

.atch-img {
  width: 2%;
}

.download-btn-container {
  display: flex;
  align-items: flex-end;
  .img {
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 10px;
    color: #34c0be;
    margin-left: 5px;
  }
}

.download-btn {
  margin-top: 2%;
}

.file-name {
  padding: 0px 5px;
}

.rigth-margin-10 {
  margin-right: 10px;
}

.content-center {
  justify-content: center;
  text-align: center;
}

.employeeDownload{
  margin-top: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(5, 5, 5, 0.08) 0px 0px 0px 1px;
  border-radius: 2%;
  width:max-content;
  padding: 10px;
  cursor: pointer;
}

.downloadImg{
  margin-right: 10px;
}

.downloadText{
  color: #34c0be;
  font-weight: bold;
}

.download-content {
  justify-content: flex-end !important;
  text-align: center;
  align-items: center !important;
}

.attach-content {
  color: #6e6e6e !important;
  a {
    margin-left: 4px;
    margin-right: 15px;
    font-size: 14px;
    position: relative;
    top: -6px;
  }
}

.font-size-14 {
  font-size: 14px !important;
} // table header designs
.tableheader {
  display: flex;
  align-items: center;
  .action-dropdown {
    display: block;
    cursor: pointer;
    opacity: 0.1;
    position: relative;
  }
  &:hover {
    .action-dropdown {
      opacity: 1;
    }
  }
} // try
.action-container {
  position: absolute;
  display: flex;
}

.action-menu {
  width: 175px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  z-index: 1;
  padding: 20px 10px;
  position: absolute;
  top: 144%;
  padding-bottom: 10px;

  &::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    top: -10px;
    right: 30%;
    filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  }

  &#download {
    margin-left: 0px;
  }
  &#email {
    margin-left: 100px;
  }
  &#ess {
    margin-left: 200px;
  }
  .edit {
    cursor: pointer;
    margin-left: 5px;
    font-size: 12px;
    color: #616363;
    margin-bottom: 10px;
  }
  .query {
    cursor: pointer;
    margin-left: 3px;
    font-size: 12px;
    color: #616363;
  }
  .joining {
    cursor: pointer;
    margin-left: 2px;
    font-size: 12px;
    color: #616363;
  }
  .dropdown-footer {
    border-top: 1px solid #d6d4d4;
  }
}

.export-button {
  padding: 0px 5px !important;
  margin: 0px 5px !important;
  width: 100px !important;
  margin-top: -5px !important;
}

.action-section {
  margin: 0px;
  text-align: center;

  img {
    width: auto;
  }
  .action-menu {
    top: 0%;
    left: -140%;
    width: max-content;
    padding-top: 5px;
    padding-bottom: 5px;
    li {
      padding: 0px;
      font-weight: 500;
      span {
        margin: 0px 20px;
        padding: 10px;
        display: block;
      }
      &:not(:last-child) {
        span {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }
}
.payslip-modal {
  width: 60% !important;
  height: 90% !important;
  margin: 60px auto 0px auto !important;
}

.cancel-btn {
  display: block;
  border-radius: 4px;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  min-width: 60px;
  padding: 14px;
  font-size: 14px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.downLoadBtn{
    display: flex;
    gap:20px
 }
 .export-button{
    background-color:  rgba(14, 165, 235, 0.5);
    color: black;
    width: 6rem;
    height:2rem;
 }

 .model {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;

  span {
    color: #f3f3f3;
    font-size: xx-large;
  }
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3b2867;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
